import { ChangeEvent, ReactNode, useState } from 'react';
import { useSearchParams } from 'react-router';
import { useDebounce } from '@/utils/use-debounce';
import { Input } from '@mantine/core';


export function PaymentsFilters(): ReactNode {
    const debounce = useDebounce(500);
    const [ searchParams, setSearchParams ] = useSearchParams();
    const [ search, setSearch ] = useState(() => searchParams.get('search') || '');

    const onChangeSearch = (e: ChangeEvent<HTMLInputElement>) => {
        setSearch(e.target.value);
        if (!e.target.value) {
            setSearchParams((prev) => {
                prev.set('page', '1');
                prev.delete('search');
                return prev;
            });
            return;
        }
        if (e.target.value.length > 2) {
            debounce(() => {
                setSearchParams((prev) => {
                    prev.set('page', '1');
                    prev.set('search', e.target.value);
                    return prev;
                });
            })
        }
    }
    function clear() {
        setSearch('');
        setSearchParams(new URLSearchParams({} as any));
    }
    return (
        <Input
            placeholder='Search'
            value={ search }
            onChange={ onChangeSearch }
            style={ { flex: 1 }}
            rightSectionPointerEvents='all'
            rightSection={
                search ? (
                    <Input.ClearButton
                        aria-label='Clear input'
                        onClick={ () => clear() }
                    />
                ) : null
            }
        />
    );
}